/*
 * Calmont Messpunkte (Clarity, Shopify-Kundenereignisse, dataLayer) über window.calTrack aus snippets/cal-head.liquid.
 * Hier nur, was sich per Klick-Delegation erfassen lässt; Kaufbox und Vergleichs-Popup melden selbst (assets/cal-buy.js).
 * Kauf-Zuordnung: versteckte Positions-Eigenschaft „_quelle“ (kaufbox, vergleich-popup, kassen-popup, warenkorb-set, warenkorb-empfehlung).
 */
(() => {
  if (window.__calTrackReady) return; window.__calTrackReady = true;
  const T = (n, d) => { if (window.calTrack) window.calTrack(n, d || {}); };
  const once = (k) => { try { if (sessionStorage.getItem('calT:' + k)) return false; sessionStorage.setItem('calT:' + k, '1'); } catch (e) {} return true; };
  const path = (h) => { try { return new URL(h, location.href).pathname; } catch (e) { return String(h || ''); } };
  const handle = (h) => (path(h).split('/products/')[1] || '').split('/')[0];
  const txt = (el) => (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60);

  // window statt document: läuft vor dem Kassen-Popup (cal-xu.js), das den Klick sonst anhält
  window.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null; if (!t) return;
    // Mega-Menü (Desktop .cal-mm, mobil .cal-mmo)
    const mm = t.closest('.cal-mm a, .cal-mmo a');
    if (mm) {
      const p = handle(mm.getAttribute('href'));
      T('mega_klick', { ziel: path(mm.getAttribute('href')), art: p ? 'produkt' : (mm.closest('.cal-mm__teaser, .cal-mmo__teaser') ? 'teaser' : 'link'), text: txt(mm), mobil: mm.closest('.cal-mmo') ? 'ja' : 'nein' });
      return;
    }
    // Kategorieseite
    const card = t.closest('[data-cal-grid] .cal-xs__card');
    if (card) { const all = [...document.querySelectorAll('[data-cal-grid] .cal-xs__card')]; T('kategorie_produkt_klick', { produkt: handle(card.getAttribute('href')), position: all.indexOf(card) + 1 }); return; }
    if (t.closest('[data-cal-fit]')) { T('kategorie_nur_passende', { an: t.closest('[data-cal-fit]').getAttribute('aria-pressed') === 'true' ? 'aus' : 'an' }); return; }
    if (t.closest('[data-cal-dr-open]')) { T('kategorie_mehr_filter'); return; }
    if (t.closest('[data-cal-more-link]')) { T('kategorie_mehr_laden'); return; }
    const cmp = t.closest('.cal-kat-cmp a, .cal-kat-cmp button');
    if (cmp) { T('kategorie_vergleich_klick', { ziel: cmp.getAttribute('href') ? path(cmp.getAttribute('href')) : txt(cmp) }); return; }
    // Warenkorb
    const cs = t.closest('[data-cal-cset-go]');
    if (cs) { const box = cs.closest('[data-cal-cset]'); const on = box && box.querySelector('[data-cal-cset-v][aria-checked="true"]'); T('warenkorb_set_wechsel', { set: on ? txt(on) : '' }); return; }
    const up = t.closest('[data-cal-cart-add]');
    if (up) { T('warenkorb_empfehlung_hinzu', { variante: up.getAttribute('data-cal-cart-add') }); return; }
    const co = t.closest('button[name="checkout"], a[href$="/checkout"], [data-cal-checkout]');
    if (co) {
      if (Date.now() - (window.__calCoT || 0) < 3000) return; window.__calCoT = Date.now();
      const G = window.CalGift; const sub = window.CalCartSub;
      const fehlt = G && typeof sub === 'number' ? Math.max(0, G.threshold - sub) : null;
      T('kasse_klick', { geschenk: fehlt === null ? '' : fehlt === 0 ? 'erreicht' : fehlt <= 5000 ? 'knapp (bis 50 €)' : 'weit' , fehlt_euro: fehlt === null ? '' : Math.round(fehlt / 100) });
    }
  }, true);

  // Filter und Sortierung (cal-collection.js meldet jede neue Liste)
  document.addEventListener('cal:collection-updated', (e) => {
    const d = (e && e.detail) || {}; if (d.append || d.fit !== undefined || !d.url) return;
    try {
      const u = new URL(d.url); const f = [];
      u.searchParams.forEach((v, k) => { if (k.startsWith('filter.')) f.push(k.replace(/^filter\.(v|p)\.(m\.)?/, '').replace(/^option\./, '') + '=' + v); });
      const sort = u.searchParams.get('sort_by') || '';
      T('kategorie_filter', { filter: f.join(' · ').slice(0, 200), anzahl: f.length, sortierung: sort });
    } catch (er) {}
  });

  // Geschenk-Fortschritt (Summe ohne Geschenk aus cal-cart.js)
  document.addEventListener('cal:cart-sub', (e) => {
    const G = window.CalGift; const sub = e && e.detail ? e.detail.sub : null;
    if (!G || typeof sub !== 'number' || sub <= 0) return;
    if (sub >= G.threshold) { if (once('gift-ok')) T('geschenk_erreicht', { summe_euro: Math.round(sub / 100) }); }
    else if (G.threshold - sub <= 5000 && once('gift-near')) T('geschenk_knapp', { fehlt_euro: Math.round((G.threshold - sub) / 100) });
  });

  // „Zum Set wechseln“ im Warenkorb angezeigt (einmal je Sitzung)
  const seen = () => { if (document.querySelector('[data-cal-cset]') && once('cset-seen')) { T('warenkorb_set_angezeigt'); return true; } return false; };
  if (!seen()) {
    let q = 0; const mo = new MutationObserver(() => { if (q) return; q = requestAnimationFrame(() => { q = 0; if (seen()) mo.disconnect(); }); });
    const start = () => mo.observe(document.body, { childList: true, subtree: true });
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  }
})();
